import React, { useCallback, useEffect, useState } from "react";
import {
  View,
  Dimensions,
  ScrollView,
  Platform,
  RefreshControl,
} from "react-native";
import { Divider, SegmentedButtons } from "react-native-paper";
import { ids, styles } from "./TripInfoCss.js";
import TripCard from "./TripCard/TripCard.jsx";
import { GetTripApi } from "../../service/api/trip/getTripApi.js";
import AppBar from "../Layout/AppBar.jsx";
import {
  TripDetailBackColor,
  primaryColor,
  whiteColor,
} from "../../constant/constantCss.js";
import PlaneLoader from "../../components/Loader.jsx";
import TripItinerary from "./ShowDetails/component/TripItinerary.jsx";
import TripInfo from "./ShowDetails/component/TripInfo.jsx";
import TripUpdates from "./ShowDetails/component/TripUpdates.jsx";
import TripAlbums from "./ShowDetails/component/TripAlbums.jsx";
import TripRating from "./ShowDetails/component/TripRating.jsx";
import TripParticipant from "./ShowDetails/component/TripParticipant.jsx";
import { PERMISSION } from "../../constant/getAllPermission.js";
import { useSelector } from "react-redux";
import ContactUs from "../LnadingPage/components/ContactUs.jsx";
import PublicAppBar from "../Layout/PublicAppBar.jsx";
const ShowTripInfo = ({ route }) => {
  const id = route?.params?.data;
  const [tabValue, setTabValue] = useState("overview");
  const [loader, setloader] = useState(true);
  const [tripDetails, setTripDetails] = useState([]);
  const [refreshing, setRefreshing] = useState(false);
  const [refreshAPI, setRefreshAPI] = useState(false);
  const { permission, isLogin } = useSelector((state) => state.auth);

  const [announcement, setAnnouncement] = useState([]);
  const [albumList, setAlbumList] = useState([]);
  // const [componentHeight, setComponentHeight] = useState({
  //   TripCard: 0,
  //   overview: 0,
  //   itinerary: 0,
  //   updates: 0,
  //   attractions: 0,
  //   review: 0,
  //   participants: 0,
  // });

  const currentButtonStyle = (val) => ({
    borderWidth: 0,
    borderBottomWidth: 2,
    borderRadius: 2,
    backgroundColor: whiteColor,
    borderColor: tabValue === val ? primaryColor : whiteColor,
  });
  // const onTripInfoLayout = (event, type) => {
  //   setComponentHeight({ type: event.nativeEvent.layout.height });
  // };

  const tabButton = [
    {
      value: "overview",
      label: "Overview",
      style: currentButtonStyle("overview"),
    },
    {
      value: "itinerary",
      label: "Itinerary",
      style: currentButtonStyle("itinerary"),
    },
    ...(announcement.length > 0 ||
    (permission && permission.includes(PERMISSION.CAN_CREATE_ANNOUNCEMENT))
      ? [
          {
            value: "updates",
            label: "Updates",
            style: currentButtonStyle("updates"),
          },
        ]
      : []),
    ...(albumList.length > 0 ||
    (permission && permission.includes(PERMISSION.CAN_UPLOAD_ALBUMS))
      ? [
          {
            value: "attractions",
            label: "Attractions",
            style: currentButtonStyle("attractions"),
          },
        ]
      : []),
    {
      value: "review",
      label: "Reviews",
      style: currentButtonStyle("review"),
    },
    ...(permission && permission.includes(PERMISSION.CAN_ADD_CASH_PAYMENT)
      ? [
          {
            value: "participants",
            label: "Participants",
            style: currentButtonStyle("participants"),
          },
        ]
      : []),
  ];
  const initalCallingApi = () => {
    GetTripApi(id)
      .then((res) => {
        setTripDetails(res?.data?.data);
        setloader(false);
      })
      .catch((err) => {
        setloader(false);
      });
  };
  const onRefresh = useCallback(() => {
    setRefreshing(true);
    setTimeout(() => {
      initalCallingApi();
      setRefreshing(false);
    }, 1000);
  }, []);
  useEffect(() => {
    initalCallingApi();
  }, [id, refreshAPI]);
  return (
    <View style={{ backgroundColor: TripDetailBackColor }}>
      {isLogin ? <AppBar /> : <PublicAppBar />}
      <ScrollView
        refreshControl={
          <RefreshControl
            refreshing={refreshing}
            onRefresh={onRefresh}
            tintColor={primaryColor}
            colors={[primaryColor]}
          />
        }
      >
        <View style={styles.profileContainer}>
          {loader ? (
            <PlaneLoader />
          ) : (
            <View style={[styles.userProfile]}>
              <>
                <TripCard
                  tripDetails={tripDetails}
                  setRefreshAPI={setRefreshAPI}
                />
                <View style={styles.tabView}>
                  <ScrollView horizontal={true}>
                    <SegmentedButtons
                      style={{ width: Platform.OS === "web" ? "150%" : "100%" }}
                      value={tabValue}
                      onValueChange={(text) => {
                        setTabValue(text);
                        if (Platform.OS === "web") {
                          const anchor = document.createElement("a");
                          anchor.href = `#${text}`;
                          anchor.click();
                          // window.scrollTo({
                          //   top: componentHeight,
                          //   left: 0,
                          //   behavior: "smooth",
                          // });
                        }
                      }}
                      buttons={tabButton}
                    />
                  </ScrollView>
                </View>
              </>
              {/* info section */}
              <View
                style={{
                  flexDirection: "column",
                  gap: 20,
                  backgroundColor: whiteColor,
                  padding: 16,
                  marginHorizontal: 10,
                  marginTop: 4,
                  borderRadius: 10,
                }}
              >
                <TripInfo
                  tripDetails={tripDetails}
                  trip_id={id}
                  setRefreshAPI={setRefreshAPI}
                  // setComponentHeight={onTripInfoLayout}
                />
                <TripItinerary trip_id={id} />
                <TripUpdates
                  trip_id={id}
                  announcement={announcement}
                  setAnnouncement={setAnnouncement}
                />
                <TripAlbums
                  tripId={id}
                  albumList={albumList}
                  setAlbumList={setAlbumList}
                />
                <TripRating tripId={id} />
                {permission &&
                  permission.includes(PERMISSION.CAN_ADD_CASH_PAYMENT) && (
                    <TripParticipant tripId={id} tripDetails={tripDetails} />
                  )}
              </View>
            </View>
          )}
        </View>
        <ContactUs />
      </ScrollView>
    </View>
  );
};

export default ShowTripInfo;
